import * as yup from 'yup';

import { useMutation } from '@redwoodjs/web';

import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { VALIDATE_EMAIL } from 'src/graphql/mutations/userValidations.mutation';
import { useEmailAddressValidation } from 'src/utils/validateEmail';

export const useValidateEmail = () => {
    const [validateEmailAddress, { loading: validatingEmail }] = useMutation(VALIDATE_EMAIL, {
        onError: () => {
            showErrorToast('Error Validating Email');
        },
    });

    const emailSchema = yup.object().shape({
        email: yup.string().email().required(),
    });
    const { isEmailAddressValid } = useEmailAddressValidation();
    const onValidateEmail = async (email: string, onError?: () => void, onSuccess?: () => void) => {
        /** Validate the users input before making an api call */

        // Trim the email to remove leading and trailing spaces
        const trimmedEmail = email.trim();

        emailSchema
            .validate({ email: trimmedEmail })
            .then(async () => {
                const isEmailAValid = await isEmailAddressValid(trimmedEmail);
                if (isEmailAValid) {
                    showSuccessToast('Email is valid');
                    onSuccess && onSuccess();
                } else {
                    showErrorToast('Email is not valid');
                    onError && onError();
                }
            })
            .catch(() => {
                showErrorToast('Email is not valid');
                onError && onError();
            });
    };

    return { validatingEmail, onValidateEmail };
};
